<template>
  <!-- モーダルウィンドウ -->
  <div
    class="c-modal"
    :class="[classes ? classes : '', {'is-active': isActive}]"
  >
    <div class="c-modal__bg" @click="handleClickOutside"></div>
    <div class="c-modal__content">
      <div class="c-modal__close" @click="onCloseClick">
        <div class="c-icon c-icon--white u-wh14">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="/assets/img/sprite.svg#close" />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <div class="c-modal__title">{{ title }}</div>
        <div v-if="errorMessage != ''" class="c-modal__error">{{ errorMessage }}</div>

        <template v-if="isBodyHtml">
          <div class="c-modal__data" v-html="body"></div>
        </template>
        <template v-else>
          <div class="c-modal__data">{{ body }}</div>
        </template>
        <slot />
        <div class="c-modal__btns">
          <button
            v-if="cancelButtonLabel && onCancelClick"
            :class="[`c-btn c-btn--modal c-btn--gray ${buttonWidth} u-h34 u-fs14`]"
            type="button"
            name="cancel"
            value="cancel"
            @click="onCancelClick"
          >
            <p class="c-btn__text">{{ cancelButtonLabel }}</p>
          </button>
          <button
            v-if="enterButtonLabel && onEnterClick"
            :class="[`c-btn c-btn--modal c-btn--blue ${buttonWidth} u-h34 u-fs14`, {'is-loading': isLoading}]"
            type="button"
            name="delete"
            value="delete"
            :disabled="isLoading"
            @click="onEnterClick"
          >
            <p class="c-btn__text">{{ enterButtonLabel }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
<!-- /モーダルウィンドウ -->
</template>

<script>
export default {
  props: {
    classes: { type: String, required: false },
    isActive: { type: Boolean, required: true },
    isBodyHtml: { type: Boolean, required: false },
    body: { type: String, required: true },
    cancelButtonLabel: { type: String, required: false },
    enterButtonLabel: { type: String, required: false },
    title: { type: String, required: false },
    canClickOutside: { type: Boolean, required: false, default: true },
    onCancelClick: { type: Function, required: false },
    onCloseClick: { type: Function, required: true },
    onEnterClick: { type: Function, required: false },
  },
  data() {
    return {
      errorMessage: '',
      isLoading: false,
    }
  },
  computed: {
    buttonWidth: function () {
      return (this.cancelButtonLabel && this.enterButtonLabel) ? 'u-w140' : 'u-w200';
    },
  },
  methods: {
    showLoader() {
      this.isLoading = true;
    },
    hideLoader() {
      // 早すぎて変な表示になる事があるので、1拍おいてから非表示化
      setTimeout(() => {
        this.isLoading = false;
      }, 300)
    },
    toggleLoader() {
      this.isLoading = !this.isLoading;
    },
    showErrorMessage(message) {
      this.errorMessage = message;
    },
    resetErrorMessage() {
      this.errorMessage = '';
    },
    handleClickOutside() {
      this.canClickOutside && this.onCloseClick();
    },
  }
};
</script>
